var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_an-object.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_an-object.js
// module chunks = 168707334958949